import { useMemo } from 'react';
import {
  Conversation as APIConversation,
  Message as APIMessage,
} from '@sdk/messages/types/apiTypes';
import { usePersonaCollection } from '@sdk/personaCollection/PersonaCollectionContext';
import { useSession } from '@sdk/session/SessionContext';

import {
  mapBulkAPIMessages,
  mapAPIConversationToUI,
  mapAPIMessageStrategy,
} from '@web/conversations/utils/mappers';

export const useConversationMappers = () => {
  const { currentUser } = useSession();
  const personas = usePersonaCollection();

  // INFO session context is guaranteed to have loaded data
  // personas is not and can be empty
  const isReady = personas.users?.length > 0;

  return useMemo(
    () => ({
      isReady,
      mapBulkAPIMessages: (messages: APIMessage[]) =>
        mapBulkAPIMessages({ currentUser, message: messages, personaCollection: personas }),
      mapAPIConversationToUI: (conversation: APIConversation) =>
        mapAPIConversationToUI(conversation, personas, currentUser),
      mapAPIMessageStrategy: (message: APIMessage) =>
        mapAPIMessageStrategy({ currentUser, message, personaCollection: personas }),
    }),
    [currentUser, isReady, personas]
  );
};
